import { z } from 'zod'
import dayjs from 'dayjs'

let recurrenceSchema = z.object({
  recurrenceType: z.enum(['Monthly', 'Yearly']),
  recurrenceInterval: z
    .number()
    .int('Interval must be a whole number')
    .min(1, 'Interval must be at least 1')
    .max(12, 'Interval cannot exceed 12'),
  recurrenceEndDate: z
    .string()
    .optional()
    .refine(
      (date) => !date || dayjs(date).isValid(),
      'End date must be a valid date',
    ),
  dayOfMonth: z
    .number()
    .int('Day must be a whole number')
    .min(1, 'Day must be at least 1')
    .max(31, 'Day cannot exceed 31'),
})

export let scheduledAssignmentSchema = z
  .object({
    name: z.string().nonempty('Assignment name is required'),
    linkedServiceID: z.string().nonempty('Linked service is required'),
    goLiveDate: z
      .string()
      .nonempty('Go live date is required')
      .refine(
        (date) => dayjs(date).isValid(),
        'Go live date must be a valid date',
      )
      .refine(
        (date) => dayjs(date).isAfter(dayjs(), 'day'),
        'Go live date must be in the future',
      ),
    dueDate: z
      .string()
      .nonempty('Due date is required')
      .refine((date) => dayjs(date).isValid(), 'Due date must be a valid date'),
    userIDs: z.array(z.string()).min(1, 'At least one user must be selected'),
    courseIDs: z
      .array(z.string())
      .min(1, 'At least one course must be selected'),
    hasRecurrence: z.boolean(),
    recurrence: recurrenceSchema.optional(),
  })
  .refine(
    (data) => {
      if (data.hasRecurrence && !data.recurrence) {
        return false
      }
      if (data.dueDate && data.goLiveDate) {
        let goLive = dayjs(data.goLiveDate)
        let due = dayjs(data.dueDate)
        if (!due.isAfter(goLive, 'day')) {
          return false
        }
      }
      if (
        data.hasRecurrence &&
        data.recurrence &&
        data.recurrence.recurrenceEndDate
      ) {
        let goLive = dayjs(data.goLiveDate)
        let endDate = dayjs(data.recurrence.recurrenceEndDate)
        return endDate.isAfter(goLive)
      }
      return true
    },
    {
      message: 'Due date must be after go live date',
      path: ['dueDate'],
    },
  )
